export default "__VITE_ASSET__BeNCU6pl__"